import * as React from "react";
import ReactTable from "react-table";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { DetalleNovedad } from "../modelo/ConsultaNovedadesDetalle";
import { FiltroConsultaReciboDetalle } from "../../config_general_recibo/modelo/NovedadesRecibidas";
import { CODIGOS_CONSULTA } from "../../config_general_recibo/modelo/CodigosConsulta";
import { ModalDetalleJson } from "../../config_general/componentes/ModalDetalleJson";
import { Glyphicon } from "react-bootstrap";
import Toggle from 'material-ui/Toggle';

export default class TablaConsultaDetalle extends React.Component<TablaConsultaDetalleProps, any> {

    columns = [{
        id: "consecutivoResumen",
        Header: "Con.Resumen",
        accessor: "consecutivoResumen",
        Cell: props => (this.renderTexto(props)),
        width: 75
    }, {
        id: "dniEmpleador",
        Header: "Dni Empleador",
        accessor: "dniEmpleador",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }, {
        id: "usuarioTransaccionSAT",
        Header: "Usuario SAT",
        accessor: "usuarioTransaccionSAT",
        Cell: props => (this.renderTexto(props)),
        width: 130
    }, {
        id: "nombreUsuarioTransaccionSAT",
        Header: "Nombre Usuario SAT",
        accessor: "nombreUsuarioTransaccionSAT",
        Cell: props => (this.renderTexto(props)),
        width: 210
    }, {
        id: "error",
        Header: "Error",
        accessor: "error",
        Cell: props => (this.renderTexto(props)),
        width: 250
    }, {
        id: "fechaIngresoSAT",
        Header: "Fecha Ingreso",
        accessor: "fechaIngresoSAT",
        Cell: props => (this.renderTexto(props)),
        width: 140
    }, {
        id: "estado",
        Header: "Estado",
        accessor: "estado",
        Cell: props => (this.renderTexto(props)),
        width: 60
    }, {
        id: "otrosCampos",
        Header: "Detalle",
        accessor: "otrosCampos",
        Cell: props => (this.renderDetalleJson(props, props.original.otrosCampos)),
        width: 75
    }, {
        id: "consecutivo",
        Header: "Seleccionar",
        accessor: "consecutivo",
        Cell: props => (this.renderCheckBox(props)),
        width: 70
    }];

    constructor(props: any) {
        super(props);

        this.state = {
            masivoActivado: false,
            listaCambioEstado: [],
            listaEnvioCambioEstado: []
        };
    }

    componentDidUpdate() {
        if (this.props.enviarCambiosEstado) {
            this.enviarCambiosEstado();
        }
    }

    render() {
        const { registros, paginas, tamanoPagina, paginaActual, totalRegistros } = this.props;
        const { masivoActivado } = this.state;
        let numRegistros = 0;

        if (registros.length < tamanoPagina) {
            numRegistros = registros.length;
        } else {
            numRegistros = tamanoPagina;
        }

        const tooltipToggle = (
            <Tooltip id="tooltip">
                <span className="tooltip-font">{masivoActivado ? 'Desactivar' : 'Activar'} la gestión masiva de glosas en SAT</span>
            </Tooltip>
        );

        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{totalRegistros}</span> Registros encontrados
                    </h2>
                    <div className="icon-head-toggle">
                        <OverlayTrigger placement="top" overlay={tooltipToggle}>
                            <Glyphicon className={"cog"} glyph={"cog"} style={{ marginLeft: "-120px" }} />
                        </OverlayTrigger>
                    </div>
                    <div className="position-head-toggle">
                        <Toggle
                            style={{ marginBottom: 16 }}
                            thumbSwitchedStyle={{ backgroundColor: '#00aec7' }}
                            trackSwitchedStyle={{ backgroundColor: '#3895a3' }}
                            onToggle={(event: object, inputToggle: boolean) => this.cambioEstadoMasivo(inputToggle)}
                            toggled={this.state.masivoActivado}
                        />
                    </div>
                </div>
                <ReactTable data={registros}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    cambioEstadoMasivo = (inputToggle: boolean) => {
        if (inputToggle) {
            const { registros } = this.props;
            const listaCambioEstado = registros.map(registro => registro.consecutivo);
            this.modificarEstado(true, listaCambioEstado);
        } else {
            this.modificarEstado(false, []);
        }
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const { filtro } = this.props;
        const filtroConsulta: FiltroConsultaReciboDetalle = {
            dniEmpleador: filtro.dniEmpleador,
            fechaInicial: filtro.fechaInicial,
            fechaFinal: filtro.fechaFinal,
            servicio: filtro.servicio,
            estados: filtro.estados,
            consecutivoSolicitud: filtro.consecutivoSolicitud,
            codigoConsulta: CODIGOS_CONSULTA.CONSULTA_NOVEDADES_DETALLE,
            dniUsuarioOperacion: filtro.dniUsuarioOperacion,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex
        };
        this.setState({ listaEnvioCambioEstado: [] });
        this.modificarEstado(false, []);
        this.props.consultaPaginada(filtroConsulta);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderTexto = (props: any) => {
        if (props.value || !isNaN(props.value)) {
            if (props.value.length > 20) {
                const tooltip = (
                    <Tooltip id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{props.value}</Tooltip>
                );
                return (
                    <div style={{ marginTop: '10px' }}>
                        <OverlayTrigger placement="top" overlay={tooltip}>
                            <span>{props.value}</span>
                        </OverlayTrigger>
                    </div>
                );
            }
            return (
                <div style={{ marginTop: '10px' }}>
                    <span>{props.value}</span>
                </div>
            );
        }
        return (props.value);
    }

    renderDetalleJson = (props: any, stringJson: string) => {
        const subTitulo = `Consecutivo Mensaje: # ${props.original.consecutivo}`;
        return (
            <div style={{ marginTop: '5px' }}>
                <ModalDetalleJson
                    titulo={props.original.nombreServicio}
                    subTitulo={subTitulo}
                    stringJson={stringJson}
                />
            </div>
        );
    }

    renderCheckBox = (props: any) => {
        const { masivoActivado } = this.state;
        const consecutivo = props.original.consecutivo;
        if (this.estaEnListaDeEnviados(consecutivo)) {
            return (
                <span className="icons-table">
                    <Glyphicon glyph={"transfer"} />
                </span>
            );
        }
        return (
            <div className={"text-center"}>
                <input type="checkbox"
                    disabled={masivoActivado}
                    className={"checkbox-center"}
                    checked={masivoActivado ? true : this.estaEnlista(consecutivo)}
                    onChange={() => this.insertarRemoverRegistro(consecutivo)}
                />
            </div>
        );
    };

    estaEnListaDeEnviados = (consecutivo: number) => {
        const { listaEnvioCambioEstado } = this.state;
        if (!listaEnvioCambioEstado || listaEnvioCambioEstado.lenght === 0) return false;
        return listaEnvioCambioEstado.some((consecutivoLista: number) => consecutivoLista === consecutivo);
    };

    estaEnlista = (consecutivo: number) => {
        const { listaCambioEstado } = this.state;
        if (!listaCambioEstado || listaCambioEstado.lenght === 0) return false;
        return listaCambioEstado.some((consecutivoLista: number) => consecutivoLista === consecutivo);
    };

    buscarIndice = (consecutivo: number) => {
        const { listaCambioEstado } = this.state;
        return listaCambioEstado.indexOf(consecutivo);
    };

    insertarRemoverRegistro = (consecutivo: number) => {
        const { masivoActivado, listaCambioEstado } = this.state;
        const indice = this.buscarIndice(consecutivo);
        if (indice !== -1) {
            listaCambioEstado.splice(indice, 1);
        } else {
            listaCambioEstado.push(consecutivo);
        }
        this.modificarEstado(masivoActivado, listaCambioEstado);
    };

    modificarEstado = (activar: boolean, listaCambioEstado: Array<number>) => {
        this.setState({ masivoActivado: activar, listaCambioEstado: listaCambioEstado });
        this.props.mostrarModalCambioEstado(listaCambioEstado.length > 0);
    };

    enviarCambiosEstado = () => {
        const { listaCambioEstado, listaEnvioCambioEstado } = this.state;
        const servicio = this.props.registros.map(detalle => detalle.codigoServicio);
        const todosIguales = servicio => servicio.every(valor => valor === servicio[0]);

        if (listaCambioEstado.length > 0 && todosIguales) {
            const lista = listaEnvioCambioEstado.concat(listaCambioEstado);
            this.setState({ listaEnvioCambioEstado: lista });
            this.props.envioEstados(listaCambioEstado, servicio[0]);
            this.modificarEstado(false, []);
        }
    }
}

interface TablaConsultaDetalleProps {
    registros: Array<DetalleNovedad>
    filtro: FiltroConsultaReciboDetalle,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    totalRegistros: number,
    consultaPaginada: (filtro: FiltroConsultaReciboDetalle) => void,
    mostrarModalCambioEstado: (activar: boolean) => void,
    enviarCambiosEstado: boolean,
    envioEstados: (consecutivos: Array<number>, servicio: number) => void
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_detalle/componentes/TablaConsultaDetalle.tsx